import { Component, OnInit } from '@angular/core';
import { makeStateKey, TransferState } from '@angular/platform-browser';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SharedService } from 'src/app/modules/shared/_services/shared.service';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-trending-section',
  templateUrl: './trending-section.component.html',
  styleUrls: ['./trending-section.component.scss']
})
export class TrendingSectionComponent implements OnInit {
  trendingStates: any[] = [];
  trendingCities: any[] = [];
  trendingKeywords: any[] = [];
  trendingAuthorities: any[] = [];
  trendingSearchList: any[] = [];
  baseUrl: string = environment.TENDER.BASE_URL;
  formattedValue: string = '';

  constructor(
    private transferState: TransferState,
    private router: Router,
    private sharedService: SharedService
  ) { }

  ngOnInit(): void {
    const urlSegments = this.router.url.split('/');
    if (urlSegments.length > 2) {
      const type = urlSegments[1];
      const rawValue = urlSegments[2];

      if (type === 'city') {
        const thirdrawValue = urlSegments[3];
        this.formattedValue = this.transformToCamelCase(thirdrawValue);
        this.retrieveData(type, thirdrawValue);
      } else {
        this.formattedValue = this.transformToCamelCase(rawValue);
        this.retrieveData(type, rawValue);
      }

    }
  }

  retrieveData(type: string, value: string): void {
    this.getTrendingData(type, value, 'tenders');
    this.getTrendingData(type, value, 'searches');
  }

  getTrendingData(type: string, value: string, dataType: 'tenders' | 'searches'): void {
    const dataKey = makeStateKey<any>(`${dataType}Data`);
    if (this.transferState.hasKey(dataKey)) {
      this.handleStateData(this.transferState.get(dataKey, {}), dataType);
      this.transferState.remove(dataKey);
    } else {
      const apiCall = dataType === 'tenders'
        ? this.sharedService.retrievetrending(type, value)
        : this.sharedService.retrievetrendingSearches(type, value);

      apiCall.pipe(catchError(() => of({ code: 500 })))
        .subscribe(
          (res: any) => this.handleApiData(res?.data || {}, dataType, dataKey),
          (error) => this.logError(error)
        );
    }
  }

  handleApiData(data: any, dataType: 'tenders' | 'searches', dataKey: any): void {
    if (dataType === 'tenders') {
      this.trendingStates = data.trendingStates || [];
      this.trendingCities = data.trendingCities || [];
      this.trendingKeywords = data.trendingKeywords || [];
      this.trendingAuthorities = data.trendingAuthorities || [];
    } else {
      this.trendingSearchList = data;
    }

    if (this.sharedService.isServer) {
      this.transferState.set(dataKey, data);
    }
  }

  handleStateData(data: any, dataType: 'tenders' | 'searches'): void {
    if (dataType === 'tenders') {
      this.trendingStates = data.trendingStates || [];
      this.trendingCities = data.trendingCities || [];
      this.trendingKeywords = data.trendingKeywords || [];
      this.trendingAuthorities = data.trendingAuthorities || [];
    } else {
      this.trendingSearchList = data || [];
    }
  }

  transformToCamelCase(value: string): string {
    const valueWithSpaces = value.replace(/-/g, ' ');
    return valueWithSpaces.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ');
  }

  logError(error: any): void {
    console.error('Error in subscription:', error);
  }

  navigateToTenders(link: string): void {
    this.router.navigate([`/${link}-tenders/active`]);
  }

  navigate(event: MouseEvent, link: string): void {
    event.preventDefault();
    this.router.navigate([link]);
  }
}